import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Bell, Heart, MessageCircle, UserPlus, HandHelping } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import { it as itLocale } from "date-fns/locale";

const iconFor = (t) => {
    if (t === "like") return Heart;
    if (t === "comment") return MessageCircle;
    if (t === "connection_request" || t === "connection_accepted") return UserPlus;
    if (t === "help_reply") return HandHelping;
    if (t === "message") return MessageCircle;
    return Bell;
};

const linkFor = (n) => {
    if (n.meta?.from_user) return `/profile/${n.meta.from_user}`;
    if (n.meta?.help_id) return `/help`;
    return "#";
};

const Notifications = () => {
    const [items, setItems] = useState([]);
    const load = async () => {
        try {
            const { data } = await api.get("/notifications");
            setItems(data);
            await api.post("/notifications/read-all");
        } catch {}
    };
    useEffect(() => { load(); }, []);

    return (
        <div className="max-w-2xl mx-auto" data-testid="notifications-page">
            <h1 className="font-heading text-4xl mb-6">Notifiche</h1>
            <div className="bg-paper rounded-2xl border border-border-line overflow-hidden">
                {items.length === 0 && <div className="p-10 text-center text-muted text-sm">Nessuna notifica</div>}
                {items.map((n) => {
                    const Icon = iconFor(n.type);
                    return (
                        <Link key={n.id} to={linkFor(n)} className={`flex items-start gap-3 px-5 py-4 border-b border-border-line last:border-0 hover:bg-surface transition-colors ${!n.read ? "bg-surface/40" : ""}`}>
                            <div className="w-9 h-9 rounded-full bg-surface border border-border-line flex items-center justify-center shrink-0">
                                <Icon size={16} className="text-bordeaux" />
                            </div>
                            <div className="flex-1">
                                <div className="text-sm text-ink">{n.text}</div>
                                <div className="text-xs text-muted mt-1">{formatDistanceToNow(new Date(n.created_at), { addSuffix: true, locale: itLocale })}</div>
                            </div>
                            {!n.read && <span className="w-2 h-2 rounded-full bg-bordeaux mt-2" />}
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default Notifications;
